<template>
  <v-container class="py-6">
    <div class="text-center">
      <img
        src="/images/title-fmafs-1.png"
        aspect-ratio="16/9"
        alt=""
        height="41"
        class="mr-1 ourimage"
        @click="goToHome()"
      >
      <br />
      &nbsp;
    </div>
    <v-card class="pa-3 mx-auto" max-width="500">
      <v-card-title>
        <v-divider class="my-1"></v-divider>
        <div class="mx-2">Sign In</div>
        <v-divider class="my-1"></v-divider>
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="email" label="Email" outlined></v-text-field>
        <v-text-field
          v-model="password"
          label="Password"
          :type="showIcon ? 'text' : 'password'"
          outlined
          :append-icon="showIcon ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showIcon = !showIcon"
        ></v-text-field>
        <v-btn
          block
          class="success"
          x-large
          :disabled="signinBtnStatus"
          @click="signIn"
        >
          {{ signinBtnText }}
        </v-btn>

        <div class="text-center mt-2 text-body-2">
          <router-link to="#">Forgot your password?</router-link>
        </div>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" right>
      {{ snackbartext }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
//import router from '../router'
import httpServ from '../services/HTTPService'

export default {
  data: () => ({
    //email: 'chrisushie@hotmail.com',
    //password: 'password',
    email: '',
    password: '',
    showIcon: false,
    signinBtnStatus: false,
    signinBtnText: 'Sign In',
    snackbar: false,
    snackbartext: ''
  }),
  created() {
    httpServ.clearSession()
  },
  methods: {
    goToHome: function () {
      window.location.href = httpServ.getHomeUrl()
    },
    signIn: function () {
      this.signinBtnStatus = true
      this.signinBtnText = 'Processing ...'

      const loginData = {
        email: this.email,
        password: this.password
      }

      //FETCH
      const url = httpServ.getAuthenUrl('/members/getAccess')
      const resp = httpServ.postFetch(url,loginData)

      resp.then((result) => {
        if (result.status === 200) {
          this.snackbartext = 'Login Successful'
          this.snackbar = true
          this.signinBtnText = 'Successful'
          const memberData = result.data

          memberData.noticeSummarySpeech = true
          memberData.displayLOB = 'main_line_of_business'// for setting the current LOB
         
          httpServ.setSessionJson('memberData',memberData)
          setTimeout(() => {
            this.$router.push({ name: 'dashboard' })
          }, 1000)
        } else {
          this.snackbartext = result.message
          this.snackbar = true
          this.signinBtnStatus = false
          this.signinBtnText = 'Sign In'
        }
      })
    }
  }
}
</script>
<style scoped>
.ourimage:hover {
  cursor: pointer;
}
</style>
//TODO forgot password
//TODO network timeout
